<h2 mat-dialog-title>{{ "PWA.IOS_TITLE" | translate }}</h2>

<mat-dialog-content class="pwa-ios-dialog__content">
  <p class="pwa-ios-dialog__intro">
    {{ "PWA.IOS_INTRO" | translate }}
  </p>

  <ol class="pwa-ios-dialog__steps">
    <li class="pwa-ios-dialog__step">
      <mat-icon class="pwa-ios-dialog__step-icon">ios_share</mat-icon>
      <span>{{ "PWA.IOS_STEP_1" | translate }}</span>
    </li>
    <li class="pwa-ios-dialog__step">
      <mat-icon class="pwa-ios-dialog__step-icon">add_box</mat-icon>
      <span>{{ "PWA.IOS_STEP_2" | translate }}</span>
    </li>
    <li class="pwa-ios-dialog__step">
      <mat-icon class="pwa-ios-dialog__step-icon">check_circle</mat-icon>
      <span>{{ "PWA.IOS_STEP_3" | translate }}</span>
    </li>
  </ol>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="dialogRef.close()">
    {{ "GENERIC.OK" | translate }}
  </button>
</mat-dialog-actions>
